import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { AiOutlineFileSync } from "react-icons/ai";
import GovPortalForm from "./GovPortalForm";
import { useNavigate } from "react-router-dom";
import AuthorizeVisaForm from "./AuthorizeVisaForm";
import VisaUpdateForm from "./VisaUpdateForm";

export default function ListDataVrf({
  vrfData = [],
  titles = [],
  Loading,
  setUpdateVrfData,
  setVRFData,
  Data,
  FilterValue,
  setFilterValue,
}) {
  const navigate = useNavigate();
  const dashboardData = useSelector((state) => state.dashboardData);

  const [openGovForm, setOpenGovForm] = useState({
    open: false,
    vrfId: "",
    reqVisaQuantity: "",
  });
  const [openAutherizedForm, setOpenAutherizedForm] = useState({
    open: false,
    vrfId: "",
  });
  const [openVisaUpdate, setOpenVisaUpdate] = useState({
    open: false,
    vrfId: "",
  });

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    setResetPagination,
    Search,
    currentList,
  } = useSearchPagination(vrfData);

  const checkAccess = (module, name) => {
    return checkAccessFn(dashboardData, module, name);
  };

  const StatusFilterHandler = (value) => {
    setFilterValue(value);
    setResetPagination((prev) => !prev);
  };

  return (
    <>
      {openGovForm.open && (
        <GovPortalForm
          setUpdateVrfData={setUpdateVrfData}
          setOpenGovForm={setOpenGovForm}
          openGovForm={openGovForm}
        />
      )}
      {openAutherizedForm.open && (
        <AuthorizeVisaForm
          setOpenAutherizedForm={setOpenAutherizedForm}
          openAutherizedForm={openAutherizedForm}
          setUpdateVrfData={setUpdateVrfData}
        />
      )}
      {openVisaUpdate.open && (
        <VisaUpdateForm
          setOpenVisaUpdate={setOpenVisaUpdate}
          openVisaUpdate={openVisaUpdate}
          setUpdateVrfData={setUpdateVrfData}
        />
      )}

      <div className="p-4 uppercase">
        <div className="mb-2 ">
          <label className="font-medium mb-1 text-sm block" htmlFor="">
            Status Filter
          </label>
          <select
            onChange={(e) => StatusFilterHandler(e.target.value)}
            className="select uppercase w-56 select-sm select-bordered"
            name=""
            id=""
            value={FilterValue}
          >
            <option value="All">All</option>
            <option value="Pending">Pending</option>
            <option value="Completed">Completed</option>
          </select>
        </div>

        <div className="flex md:flex-row flex-col uppercase justify-between items-end">
          <Search
            keywords={[
              "vrf_no",
              "project.name",
              "company.name",
              "project_vendor.vendor.name",
              "status",
              "gr_status",
              "nationality.name",
              "job_position.name",
              "visa_profession.name",
            ]}
          />
          <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        </div>
        <div
          className={`grid justify-items-center grid-cols-table-GR-VRF auto-cols-min gap-5 p-6 bg-white  w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}
          {Loading && <LoadingWithLable className="col-span-full" />}
          <NoDataFound />

          {currentList?.map((listItem, index) => (
            <React.Fragment key={index}>
              <PaginationIndex index={index} />
              <p>{listItem?.vrf_no} </p>
              <p>{listItem?.project?.name}</p>
              <p>{listItem?.company?.name}</p>

              <p>{listItem?.project_vendor?.vendor?.name} </p>
              <p>{listItem?.gr_status} </p>

              <p>{listItem?.remark ? listItem?.remark : "---"}</p>

              <p
                className={
                  listItem?.visa_quantity <= listItem?.available_quantity
                    ? "text-green-500"
                    : "text-red"
                }
              >
                {listItem?.visa_quantity}
              </p>
              <p>
                {listItem?.gr_requested_visa_quantity
                  ? listItem?.gr_requested_visa_quantity
                  : "---"}
              </p>
              <p>{listItem?.job_position?.name}</p>
              <p>{listItem?.nationality?.name}</p>
              <p>{listItem?.visa_profession?.name}</p>
              <p>{listItem?.available_quantity}</p>
              <div className="relative">
                {(listItem?.gr_status === "Pending" &&
                  listItem?.status === "Not Issued" &&
                  listItem?.visa_quantity <= listItem?.available_quantity) ||
                (listItem?.visa_quantity > listItem?.available_quantity &&
                  listItem?.visa_process_in_gov_portal === "Not Started" &&
                  listItem?.status === "Not Issued") ||
                (listItem?.finance_status === "Completed" &&
                  listItem?.gr_status === "Pending" &&
                  listItem?.stock_update === "NO" &&
                  listItem?.status === "Not Issued") ||
                (listItem?.file !== "" &&
                  listItem?.gr_status == "Completed") ? (
                  <button className="rounded-md bg-white p-2 text-sm text-black peer ">
                    <BiDotsVerticalRounded size={"1.4rem"} />
                  </button>
                ) : (
                  "---"
                )}

                <div className="hidden absolute bottom-0 right-7 max-w-xs w-[17rem] h-auto bg-white shadow-xl rounded-lg p-2 dark:bg-dark2 ring-1 ring-slate-400 dark:ring-black peer-hover:block hover:block">
                  {listItem?.gr_status === "Pending" &&
                    listItem?.status === "Not Issued" &&
                    listItem?.visa_quantity <= listItem?.available_quantity && (
                      <button
                        className="w-full"
                        onClick={() =>
                          setOpenAutherizedForm({
                            open: true,
                            vrfId: listItem?.id,
                          })
                        }
                      >
                        <p className="bg-white shadow-sm uppercase p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                          Authorize
                        </p>
                      </button>
                    )}
                  {listItem?.visa_quantity > listItem?.available_quantity &&
                    listItem?.visa_process_in_gov_portal === "Not Started" &&
                    listItem?.status === "Not Issued" && (
                      <button
                        onClick={() =>
                          setOpenGovForm({
                            open: true,
                            vrfId: listItem?.id,
                            reqVisaQuantity: listItem?.visa_quantity,
                          })
                        }
                        className="w-full"
                      >
                        <p className="bg-white shadow-sm uppercase  p-2 w-full mb-1 hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red text-left">
                          Start Visa process in Gov portal
                        </p>
                      </button>
                    )}
                  {listItem?.finance_status === "Completed" &&
                    listItem?.gr_status === "Pending" &&
                    listItem?.stock_update === "NO" &&
                    listItem?.status === "Not Issued" && (
                      <button
                        onClick={() =>
                          setOpenVisaUpdate({ open: true, vrfId: listItem?.id })
                        }
                        className="w-full"
                      >
                        <p className="bg-white p-2 w-full uppercase hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center gap-3">
                          Update Visa Quantity
                        </p>
                      </button>
                    )}
                  {listItem?.file !== "" &&
                    listItem?.gr_status == "Completed" && (
                      <Link target="_blank" to={listItem?.file}>
                        <button
                          // onClick={() =>
                          //   downloadFile("annexure", list?.contract?.id)
                          // }
                          className="w-full"
                        >
                          <p className="bg-white p-2 w-full uppercase hover:bg-red rounded-md hover:text-white dark:bg-dark2 dark:hover:bg-red flex items-center">
                            <AiOutlineFileSync className="mr-2" /> VRF File
                          </p>
                        </button>
                      </Link>
                    )}
                </div>
              </div>
              <hr className="border-[1.5px] border-slate-100  w-full col-span-full" />
            </React.Fragment>
          ))}
        </div>

        <Pagination />
        <div className="flex justify-center items-center w-full"></div>
      </div>
    </>
  );
}
